import React, { useState } from "react";
import { Input } from "../../components/Input";
import { Field, Label, Switch } from "@headlessui/react";
import ButtonGroup from "./ButtonGroup";

const GROUP_BTN_TYPES = [
  {
    id: 1,
    label: "Single Group",
    description: "Mixers / Networking",
  },
  {
    id: 2,
    label: "Dual Group",
    description: "Dating / Matching",
  },
];

// Capacity used to be the "Size" steppers here, which only admins could see.
// It is CapacityInput in the main form now (GIS-266).
const GroupNamesInput = ({
  group,
  onSittersChange,
  onMoversChange,
  event,
  handleChange,
}) => {
  const [groupCount, setGroupType] = useState(event.groupCount);

  const onGroupTypeChange = (button) => {
    if (event.groupCount === button.id) return;
    handleChange("groupCount", button.id);
    setGroupType(button.id);
  };

  return (
    <div className="">
      <ButtonGroup
        buttons={GROUP_BTN_TYPES}
        onSelected={onGroupTypeChange}
        defaultSelected={event.groupCount}
        label="Group Type"
      />
      <div className="mb-2 flex gap-4">
        <Input
          label="Sitters Name"
          value={group.sitters}
          type="text"
          className="mr-2"
          onChange={onSittersChange}
        />
        {groupCount === 2 && (
          <Input
            label="Movers Name"
            value={group.movers}
            type="text"
            onChange={onMoversChange}
          />
        )}
      </div>

      <div className="mt-4 max-w-80">
        <Field className="flex items-center justify-between">
          <Label as="span" className="text-sm font-medium text-gray-500 dark:text-gray-400">
            Show Badge/Table Number
          </Label>
          <Switch
            checked={event.showBadgeTableNumber}
            onChange={(checked) =>
              handleChange("showBadgeTableNumber", checked)
            }
            className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 dark:bg-gray-700 transition-colors duration-200 ease-in-out focus:outline-none data-[checked]:bg-primary dark:data-[checked]:bg-primary"
          >
            <span
              aria-hidden="true"
              className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white dark:bg-gray-800 shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
            />
          </Switch>
        </Field>
      </div>
    </div>
  );
};

export default GroupNamesInput;
